// extracted by mini-css-extract-plugin
export default {"container":"yG_H5","header":"VjSsz","time-recorded":"TdP6Y"};